// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__VkLDW","floatingLabel":"Label_floatingLabel__Ct79M","floatingLabelText":"Label_floatingLabelText__JRuXT","focused":"Label_focused__t2RKl"};